document.addEventListener('DOMContentLoaded', () => {
  initHomepageSections();
});

document.addEventListener('shopify:section:load', () => {
  initHomepageSections();
});

function initHomepageSections() {
  setupHeroSlider();
  document.querySelectorAll('[data-product-rail]').forEach((rail) => {
    setupPager({
      gridId: rail.dataset.gridId,
      tabsId: rail.dataset.tabsId,
      prevId: rail.dataset.prevId,
      nextId: rail.dataset.nextId,
      counterId: rail.dataset.counterId,
    });
  });
}

function setupHeroSlider() {
  const hero = document.getElementById('hero');
  if (!hero) return;
  if (hero.dataset.sliderReady === 'true') return;
  hero.dataset.sliderReady = 'true';

  const slides = Array.from(hero.querySelectorAll('.hero-slide'));
  const dotsEl = hero.querySelector('#heroDots');
  const numEl = hero.querySelector('#heroNum');
  const totalEl = hero.querySelector('#heroTotal');
  const headlineEl = hero.querySelector('#heroHeadline');
  const ledeEl = hero.querySelector('#heroLede');
  const cta1 = hero.querySelector('#heroCta1');
  const cta2 = hero.querySelector('#heroCta2');
  const prev = hero.querySelector('#heroPrev');
  const next = hero.querySelector('#heroNext');

  if (!slides.length || !dotsEl || !numEl || !totalEl || !headlineEl || !ledeEl || !cta1 || !cta2) {
    return;
  }

  const autoplayEnabled = hero.dataset.autoplay !== 'false';
  const intervalMs = parseInt(hero.dataset.interval || '6000', 10);
  let current = 0;
  let timer;

  totalEl.textContent = String(slides.length).padStart(2, '0');
  dotsEl.innerHTML = slides
    .map((_, index) => `<button type="button" data-i="${index}" aria-label="Go to slide ${index + 1}" ${index === 0 ? 'aria-current="true"' : ''}></button>`)
    .join('');

  const dots = Array.from(dotsEl.querySelectorAll('button'));

  function applyButton(button, slide, prefix) {
    const label = slide.dataset[`${prefix}Label`] || slide.dataset[prefix] || '';
    const href = slide.dataset[`${prefix}Href`] || '';
    const style = slide.dataset[`${prefix}Style`] || '';
    const textSpan = button.querySelector('span');
    const isHidden = !label || !href;

    if (textSpan) textSpan.textContent = label;
    if (isHidden) {
      button.removeAttribute('href');
    } else {
      button.href = href;
    }
    button.hidden = isHidden;
    button.setAttribute('aria-hidden', isHidden ? 'true' : 'false');
    button.classList.remove('btn-on-color', 'btn-on-color-outline', 'btn-primary', 'btn-secondary');
    if (style) button.classList.add(style);
  }

  function goTo(index) {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('active', slideIndex === current);
      slide.setAttribute('aria-hidden', slideIndex === current ? 'false' : 'true');
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('active', dotIndex === current);
      dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
    });

    const activeSlide = slides[current];
    headlineEl.innerHTML = activeSlide.dataset.headline || '';
    ledeEl.textContent = activeSlide.dataset.lede || '';
    numEl.textContent = String(current + 1).padStart(2, '0');
    applyButton(cta1, activeSlide, 'cta1');
    applyButton(cta2, activeSlide, 'cta2');
  }

  function restart() {
    window.clearInterval(timer);
    if (!autoplayEnabled) return;
    timer = window.setInterval(() => goTo(current + 1), Number.isNaN(intervalMs) ? 6000 : intervalMs);
  }

  function handleEditorBlockSelect(event) {
    const target = event.target;
    if (!(target instanceof Element) || !hero.contains(target)) return;
    const selectedSlide = target.closest('.hero-slide');
    if (!selectedSlide) return;
    const selectedIndex = slides.indexOf(selectedSlide);
    if (selectedIndex < 0) return;
    goTo(selectedIndex);
    window.clearInterval(timer);
  }

  function handleEditorBlockDeselect(event) {
    const target = event.target;
    if (!(target instanceof Element) || !hero.contains(target)) return;
    restart();
  }

  prev?.addEventListener('click', () => {
    goTo(current - 1);
    restart();
  });

  next?.addEventListener('click', () => {
    goTo(current + 1);
    restart();
  });

  dotsEl.addEventListener('click', (event) => {
    const button = event.target.closest('button');
    if (!button) return;
    const index = parseInt(button.dataset.i || '0', 10);
    goTo(index);
    restart();
  });

  hero.addEventListener('mouseenter', () => window.clearInterval(timer));
  hero.addEventListener('mouseleave', restart);
  hero.addEventListener('focusin', () => window.clearInterval(timer));
  hero.addEventListener('focusout', restart);

  document.addEventListener('shopify:block:select', handleEditorBlockSelect);
  document.addEventListener('shopify:block:deselect', handleEditorBlockDeselect);

  goTo(0);
  restart();
}

function setupPager({ gridId, tabsId, prevId, nextId, counterId }) {
  const grid = document.getElementById(gridId);
  if (!grid) return;
  if (grid.dataset.pagerReady === 'true') return;
  grid.dataset.pagerReady = 'true';

  const cards = Array.from(grid.children);
  const prev = document.getElementById(prevId);
  const next = document.getElementById(nextId);
  const counter = document.getElementById(counterId);
  const tabs = tabsId ? Array.from(document.querySelectorAll(`#${tabsId} button`)) : [];
  let page = 0;
  let activeCategory = 'all';
  let lastPerPage = 0;

  function getPerPage() {
    const width = window.innerWidth;
    if (width < 600) return 2;
    if (width < 960) return 3;
    return 4;
  }

  function filteredCards() {
    if (activeCategory === 'all') return cards;
    return cards.filter((card) => (card.dataset.cat || '').toLowerCase() === activeCategory);
  }

  function render() {
    const perPage = getPerPage();
    const visibleCards = filteredCards();
    const totalPages = Math.max(1, Math.ceil(visibleCards.length / perPage));
    page = ((page % totalPages) + totalPages) % totalPages;
    const start = page * perPage;
    const end = start + perPage;

    cards.forEach((card) => {
      card.hidden = true;
      card.style.display = 'none';
    });

    visibleCards.slice(start, end).forEach((card) => {
      card.hidden = false;
      card.style.display = '';
    });

    if (counter) {
      counter.textContent = `${page + 1} / ${totalPages}`;
    }

    if (prev) prev.disabled = totalPages <= 1;
    if (next) next.disabled = totalPages <= 1;
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      activeCategory = (tab.dataset.cat || 'all').toLowerCase();
      page = 0;
      render();
    });
  });

  prev?.addEventListener('click', () => {
    page -= 1;
    render();
  });

  next?.addEventListener('click', () => {
    page += 1;
    render();
  });

  window.addEventListener('resize', () => {
    const nextPerPage = getPerPage();
    if (nextPerPage !== lastPerPage) {
      page = 0;
      render();
    }
  });

  if (tabs.length) {
    const defaultTab = tabs.find((tab) => tab.classList.contains('active')) || tabs[0];
    activeCategory = (defaultTab?.dataset.cat || 'all').toLowerCase();
    tabs.forEach((tab) => tab.setAttribute('aria-selected', tab === defaultTab ? 'true' : 'false'));
  }

  lastPerPage = getPerPage();
  render();
}
